var a = ((a2) => (a2.NarrowingDevice = "c19532dd-7ab6-4ecf-ab48-89347d9274a2", a2.Household = "284638e1-70d9-4af5-ac86-ffe1de6bf208", a2.Industrial = "3c1a5cc3-f42e-4d61-9462-ba49c189f657", a2))(a || {});
export {
  a as MeteringNodeTypeEnum
};
//# sourceMappingURL=types.js.map
